/**
 * 江西移动 和我信
 */
import env from '../env';
// eslint-disable-next-line import/no-cycle
import BrowserCallNative from './BrowserCallNative';
import dialog from '../../components/dialog/store';

export default class HewoxinCallNative extends BrowserCallNative {
  /**
   * 确定是否是和我信，不能再loaded之前使用
   */
  static isHewoxin() {
    if (env.isIOS) {
      return /woxin_IOS/i.test(navigator.userAgent);
    } if (env.isAndroid) {
      return /woxin_android/i.test(navigator.userAgent);
    }
    return false;
  }

  static getHewoxinVersion() {
    if (env.isIOS) {
      return Number(window.woxinversioncode);
    } if (env.isAndroid) {
      return Number(window.woxin.getVersonCode());
    }
    return 0;
  }

  static isOutdate() {
    const version = this.getHewoxinVersion();
    if (env.isIOS) {
      return version < 50;
    } if (env.isAndroid) {
      return version < 135;
    }
    return true;
  }

  /**
   *
   * 初始化和我信，需要在loaded时初始化好，在入口函数执行初始化
   *
   * @static
   * @memberof HewoxinCallNative
   */
  static init() {
    if (this.isHewoxin() && this.isOutdate()) {
      setTimeout(() => {
        dialog.info({
          content: '和我信版本过低，请升级后使用',
        });
      }, 500);
      return;
    }
    if (this.isHewoxin() && env.isIOS) {
      window.openhtmlgetStars = (phoneNo) => {
        this._phoneNo = phoneNo;
      };
    }
  }

  static getNativePhoneNo() {
    if (env.isIOS) {
      return Promise.resolve(this._phoneNo);
    } if (env.isAndroid) {
      return Promise.resolve(window.woxin.getCellPhone());
    }
    throw new Error('不支持的平台');
  }

  static scanQRCode() {
    return new Promise((resolve, reject) => {
      window.woxinscanresult = (result) => {
        resolve(result);
      };
      window.wxscancancel = () => {
        reject(new Error('取消扫码'));
      };

      try {
        if (env.isIOS) {
          window.wxopenscanview('yes');
        } else if (env.isAndroid) {
          window.woxin.wxopenscanview('yes');
        }
      } catch (e) {
        reject(new Error('系统错误(1)'));
      }
    });
  }
}
